module.exports = __webpack_public_path__ + "static/media/inspection-scheduled.228fce0b.svg";